var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_vm._l((_vm.cities),function(city,cityIndex){return [_c('NuxtLink',{key:city.seoName,class:{
        'text-2xl text-primary-dark': city.population > 10000,
        'text-xl text-primary':
          city.population <= 10000 && city.population > 4000,
        'text-base text-primary-light':
          city.population <= 4000 && city.population > 1000,
        'text-xs text-primary-lighter': city.population <= 1000,
      },attrs:{"to":_vm.localePath({
          name: 'professionals',
          params: { profession: _vm.profession.seoName, city: city.seoName },
        })}},[_vm._v(" "+_vm._s(city.name)+" "+_vm._s(Math.min(city.population / 1000))+" "+_vm._s(_vm.profession.name)),(cityIndex !== _vm.cities.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()]),(_vm.isCapital(city))?[_vm._v(" ("),_vm._l((_vm.cityParts),function(part,partIndex){return [_c('NuxtLink',{key:`${city.seoName}${part.seoName}`,attrs:{"to":_vm.localePath({
              name: 'professionalsParentCity',
              params: {
                profession: _vm.profession.seoName,
                parentCity: city.seoName,
                city: part.seoName,
              },
            })}},[_vm._v(" "+_vm._s(part.name)+" "+_vm._s(part.population)+" "+_vm._s(_vm.profession.name)),(partIndex !== _vm.cityParts.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])]}),_vm._v(" ), ")]:_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }